// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"c9b6dc37","453":"1316e9de","749":"063d0103","815":"8b46b5c0","848":"030d6aff","969":"bfdd6ac8"}[chunkId] + ".chunk.js";
};